import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Alert, Table, TableHead, TableRow, TableCell, TableBody, CircularProgress, Box } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { getAtpEstimate, type ClientRequestListItem } from '../../api/cereri'

export default function AtpEstimateDialog({ target, onClose }: { target: ClientRequestListItem | null; onClose: () => void }) {
  const open = target !== null
  const { data, isLoading } = useQuery({
    queryKey: ['comercial', 'cereri', target?.id, 'estimare-atp'],
    queryFn: () => getAtpEstimate(target!.id),
    enabled: open,
  })

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Estimare livrare (ATP) — {target?.number}</DialogTitle>
      <DialogContent>
        {isLoading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}><CircularProgress size={24} /></Box>
        )}
        {data && (
          <>
            <Alert severity="info" sx={{ mb: 2 }}>{data.summary}</Alert>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Articol</TableCell>
                  <TableCell align="right">Cantitate cerută</TableCell>
                  <TableCell align="right">Disponibil</TableCell>
                  <TableCell align="right">Acoperit din stoc</TableCell>
                  <TableCell align="right">Lipsă</TableCell>
                  <TableCell>Termen estimat</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.lines.map((l) => (
                  <TableRow key={l.lineId}>
                    <TableCell>{l.articleCode ? `${l.articleCode} — ${l.articleDescription}` : (l.articleDescription ?? '—')}</TableCell>
                    <TableCell align="right">{l.quantityThousands.toFixed(3).replace('.', ',')}</TableCell>
                    <TableCell align="right">{l.availableQuantity.toFixed(3).replace('.', ',')}</TableCell>
                    <TableCell align="right">{l.coveredFromStock.toFixed(3).replace('.', ',')}</TableCell>
                    <TableCell align="right" sx={{ color: l.shortfallQuantity > 0 ? 'error.main' : undefined, fontWeight: l.shortfallQuantity > 0 ? 600 : undefined }}>
                      {l.shortfallQuantity.toFixed(3).replace('.', ',')}
                    </TableCell>
                    <TableCell>{l.estimatedDeliveryDate ?? '—'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button onClick={onClose}>Închide</Button>
      </DialogActions>
    </Dialog>
  )
}
